export default __webpack_public_path__ + "static/media/covid-4.29215900.svg";